import queryString from "query-string";
import conversionTable from "./unitConversion.json";

export default class QueryBuilder
{
  query = {};
  page = 1;
  pageLimit = 20;
  mode = 'default';

  constructor(stateParameters, path)
  {
    this.filters = stateParameters.filters;
    this.attributeFilters = stateParameters.attributeFilters;
    this.nrfnd = stateParameters.not_recommended_fnd;
    this.rangeAttributeFilters = stateParameters.rangeAttributeFilters;
    this.sort = stateParameters.sort;
    this.page = stateParameters.page;
    this.mode = stateParameters.mode;
    this.withSeries = stateParameters.withSeries;
    this.path = path;
  }

  getBasicFilterKeys()
  {
    return ['group', 'category', 'search', 'series', 'lineup'];
  }

  // only request results if at least one basic filter is set
  // check for actual null and 'null' string because of messed up state due to url sync
  showResults()
  {
    return Object.keys(this.filters).some(
      key => {
        return this.getBasicFilterKeys().includes(key) && !!this.filters[key] && this.filters[key] !== 'null';
      }
    );

  }

  hasSeries()
  {
    return 'series' in this.filters || this.withSeries;
  }

  buildBaseQuery()
  {
    this.query['page[limit]'] = this.pageLimit;
    this.query['page[offset]'] = this.page * this.pageLimit;
    this.query['results'] = this.showResults();
    this.query['mode'] = this.mode;
    this.query['attributes'] = this.showResults();
    this.query['series'] = this.hasSeries();
  }

  applySortFilter()
  {
    if (Array.isArray(this.sort)) {
      this.sort.forEach((element, index) => {
        let key = index > 0 ? 'sort-' + index : 'sort';
        this.query['sort[' + key + '][path]'] = element.id;
        this.query['sort[' + key + '][direction]'] = element.desc ? 'DESC' : 'ASC';
      });
    }
  }

  applyBasicFilters()
  {
    for (let [key, value] of Object.entries(this.filters)) {
      if (value && value !== 'null') {
        this.query['filter[' + key + ']'] = value;
      }
    }
  }

  convertToSortableValue(value) {
    const parseStringValue = (stringVal) => {
      const [number, unit] = stringVal.split(" ");

      let factor = conversionTable[unit];
      if(factor === undefined){
        console.log(`Unit: ${unit} is missing in conversion table. Assuming factor 1.`);
        factor = 1;
      }
      const parsedNumber = parseFloat(number);
      if(isNaN(parsedNumber)) {
        return value;
      }

      return parsedNumber * factor;
    }

    if (Array.isArray(value)) {
      return value.map(arrayValue => {
        return parseStringValue(arrayValue);
      });
    } else if(typeof value === 'string') {
      return parseStringValue(value);
    }
    else {
      return value;
    }


}


  applyAttributeFilters()
  {
    for (let [key, value] of Object.entries(this.attributeFilters)) {
      if (value) {
        if(key === 'product_state') {
          this.query['filter[' + key + ']'] = value;
        } else if (key === 'not_recommended_fnd')  {

          // handle value as array
          if (Array.isArray(value)) {
            value = value[0];
          }

          this.query['filter[not_recommended_fnd]'] = value;
        }
        else {
          this.query['filter[attributes][' + key + ']'] = value;
        }
      }
    }
  }

  applyRangedAttributeFilters()
  {
    for (let [key, value] of Object.entries(this.rangeAttributeFilters)) {
      if (value) {
        this.query['filter[attributes][' + key + '][from]'] = this.convertToSortableValue(value[0]);
        this.query['filter[attributes][' + key + '][to]'] = this.convertToSortableValue(value[1]);
      }
    }
  }

  getQueryPath()
  {
    this.buildBaseQuery();
    this.applySortFilter();
    this.applyBasicFilters();
    this.applyAttributeFilters();
    this.applyRangedAttributeFilters();


    function filterLang(path) {
      const languages = [
        "de",
        "en",
        "it",
        "fr",
        "es",
        "nl",
        "pl",
      ]

      const pathSegments = path.split("/")
      if (languages.includes(pathSegments[1])) {
        pathSegments.splice(1,1)
        return pathSegments.join("/")
      } else {
        return pathSegments.join("/")
      }
    }

    const queryPath = filterLang(this.path) + '?' + queryString.stringify(this.query, {arrayFormat: 'bracket'});
    return queryPath;
  }
}
